import { defineStore } from 'pinia'
import { useEntity } from '@/composables/entity'

const useCodeStore = defineStore('codes', () => {
  const { entities: codes, selected, meta, links, loading, refetch, notFound } = useEntity<Code>()

  const setRefetch = (value: boolean): void => {
    refetch.value = value
  }

  return {
    codes,
    selected,
    meta,
    links,
    loading,
    refetch,
    notFound,
    setRefetch
  }
})

export default useCodeStore
